<nav class="navbar navbar-expand-lg navbar-light header-navbar">
  <div class="container-fluid navbar-wrapper">
    <div class="navbar-header d-flex">
      <div class="navbar-toggle menu-toggle d-xl-none d-block float-left align-items-center justify-content-center"
        data-toggle="collapse" (click)="toggleSidebar()">
        <i class="ft-menu font-medium-3"></i>
      </div>
      <div class="navbar-year">
        <label>{{ 'global.yearLabel' | translate }}</label>
        <select id="year" [formControl]="yearFormControl" class="form-control" (change)="changeYear($event.target?.value)">
          <option [value]="year" *ngFor="let year of years">{{year}}</option>
        </select>
      </div>
    </div>
    <div class="navbar-container">
      <div class="collapse navbar-collapse d-block" id="navbarSupportedContent">
        <ul class="navbar-nav">
          <li class="dropdown nav-item mr-1" placement="bottom-left" display="static" ngbDropdown >
            <a class="nav-link dropdown-toggle user-dropdown d-flex align-items-end" id="dropdownBasic2"
              href="javascript:;" data-toggle="dropdown" ngbDropdownToggle>
              <div class="user d-md-flex mr-2">
                <span class="text-right">{{ user.fullName }}</span>
                <span class="text-right text-muted font-small-3">{{ 'roles.' + user.role | translate}}</span>
              </div>
            </a>
            <div class="dropdown-menu text-left dropdown-menu-right m-0 pb-0" aria-labelledby="dropdownBasic2"
              ngbDropdownMenu>
              <a class="dropdown-item" (click)="logout();">
                <div class="d-flex align-items-center">
                  <i class="ft-power mr-2"></i><span>{{ 'global.logout' | translate}}</span>
                </div>
              </a>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</nav>
